import evaluationStates from './evaluation-states'

export default {
    button: {
        edit: 'Edit panel',
        delete: {
            true: 'Delete panel',
            false: 'There must be at least one panel'
        }
    },
    confirmation: {
        title: 'Delete panel?',
        content: 'This step can not be undone.',
        confirm: 'Yes, delete panel'
    },

    evaluationStates
}
